//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";
import {useState} from "react";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const workSlice = createSlice({
    name: 'workSlc',
    initialState: {value: {
            propertyId: null,
            expansionDepth: null,
            multiSingle: null,
            maxVersionNumber: null,
            workQueueMethodTabsIndex: 1,
            workTabsIndex: 2,
            searchScreenVisible: false,
            workDashboardVisible: false,
            workContractVisible: true,
            workIssuanceVisible: false,

            dashboardVersionId: null,
            dashboardPivotState: false,
            dashboardPivotRefresh: false,
            selectedDashboardSectionId: null

        }},
    reducers:
        // {
        //     changeWork: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeWork: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeWork } = workSlice.actions;

export default  workSlice.reducer ;
